import { ROUTES } from 'src/constants';
import { history } from 'src/utils';

export const handleBack = () => {
  history.push(ROUTES.supportManagerTasksRoute);
};
